import * as uuid from 'uuid';

export enum FileTypeEnum {
  IMAGE = 1,
  VIDEO,
  DOC_CN,
  DOC_EN,
}

export interface UploadRes {
  fileName: string;
  filePath: string;
}

export const commonUploadFile = async (
  file: File,
  businessName: string,
  ifFrontBucket: boolean,
  needRandom: boolean,
) => {
  const uploadRes = await window.$dts.dtsOss.commonUploadFile.request(
    {},
    {
      file,
      businessName,
      ifFrontBucket,
      needRandom,
    },
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  const { data } = uploadRes;

  return {
    fileName: file.name,
    filePath: data?.filePath || '',
  };
};

export const CHUNK_SIZE = 30 * 1024 * 1024;
const createFileChunk = (file: File, size = CHUNK_SIZE) => {
  const fileChunkList: Blob[] = [];
  let cur = 0;
  while (cur < file.size) {
    fileChunkList.push(file.slice(cur, cur + size));
    cur += size;
  }
  return fileChunkList;
};

export const chunkUploadFile = async (file: File) => {
  const fileChunkList = createFileChunk(file);
  const folderPath = uuid.v4();

  const chunkGroups = [];
  for (let i = 0; i < fileChunkList.length; i += 5) {
    const chunkGroup = fileChunkList.slice(i, i + 5);
    chunkGroups.push(chunkGroup);
  }

  let index = 0;
  // 依次上传每组分片
  for (const chunkGroup of chunkGroups) {
    // eslint-disable-next-line no-loop-func
    const uploadChunkPromises = chunkGroup.map((chunkData) => {
      const formData = new FormData();
      formData.append('chunkData', chunkData, index.toString());
      formData.append('folderPath', folderPath);
      formData.append('chunkName', index.toString());
      index++;
      return window.$dts.dtsOss.uploadChunk.request({}, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
    });

    await Promise.all(uploadChunkPromises); // 等待一组上传完成
  }
  return folderPath;
};

export const ossUpload = async (
  file: File,
  businessName: string,
  ifFrontBucket: boolean = false,
  needRandom: boolean = true,
): Promise<UploadRes> => {
  if (file.size <= CHUNK_SIZE) {
    const res = await commonUploadFile(file, businessName, ifFrontBucket, needRandom);
    return res;
  }
  const folderPath = await chunkUploadFile(file);

  const uploadRes = await window.$dts.dtsOss.mergeFile.request({
    folderPath,
    fileName: file.name,
    businessName,
    ifFrontBucket,
    needRandom,
  });
  const { data } = uploadRes;
  return {
    fileName: file.name,
    filePath: data?.filePath || '',
  };
};

export const getOssUrl = async (key: string): Promise<string> => {
  try {
    const res = await window.$dts.dtsOss.getSignedUrl.request({
      filePath: encodeURIComponent(key),
    });
    return res.data || '';
  } catch (err) {
    console.error('getOssUrl err: ', err);
    return '';
  }
};
